// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pCkOT","col":"styles_col__ahWEi"};